import React from 'react';

const KohlerBoldLogo = /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "98", height: "30", viewBox: "0 0 98 30", fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9814 5.36964C41.9814 2.40469 39.5681 0 36.5922 0C33.6163 0 31.2029 2.40469 31.2029 5.36964C31.2029 8.33413 33.6163 10.7389 36.5922 10.7389C39.5681 10.7389 41.9814 8.33413 41.9814 5.36964ZM36.5922 0.64506C39.2104 0.64506 41.3338 2.76106 41.3338 5.36964C41.3338 7.97801 39.2104 10.0938 36.5922 10.0938C33.9738 10.0938 31.8504 7.97801 31.8504 5.36964C31.8504 2.76106 33.9738 0.64506 36.5922 0.64506Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.819 10.6262V0.11249H25.5315C25.612 0.111594 25.6926 0.110724 25.7733 0.109634C26.6821 0.0973585 27.6022 0.0849306 28.474 0.346039C30.3015 1.11194 30.5372 4.00614 28.8571 5.06623C29.6825 5.36063 30.5079 5.89079 30.8025 6.77423C31.4215 8.33499 30.331 10.1903 28.7098 10.5142C27.7738 10.663 26.8376 10.6475 25.9016 10.632C25.7782 10.6299 25.6548 10.6279 25.5315 10.6262H24.819ZM25.5315 0.758649V4.85992C25.7873 4.85164 26.048 4.86049 26.3094 4.86936C26.9499 4.8911 27.5941 4.91296 28.1792 4.68328C29.6825 4.09424 29.6529 1.61243 28.1792 0.994175C27.5252 0.768675 26.8367 0.767402 26.1533 0.766138C25.9452 0.765753 25.7375 0.765369 25.5315 0.758649ZM27.3984 10.0024C26.7655 10.0064 26.1125 10.0025 25.5315 9.97978C25.5315 9.57693 25.5289 9.1737 25.5263 8.7703C25.5193 7.68271 25.5123 6.59331 25.5559 5.50784C25.8781 5.5244 26.205 5.52474 26.5332 5.52509C27.376 5.52596 28.2278 5.52685 29.0339 5.80247C30.4194 6.30296 30.6552 8.39387 29.5647 9.30675C28.9729 9.88144 28.198 9.99711 27.3984 10.0024Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M6.21947 0.10524H0V0.766119H2.77086V10.6262H3.48331V0.766119H6.21947V0.10524Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9556 21.1252C46.9556 16.624 43.3237 12.9745 38.8454 12.9745C34.3669 12.9745 30.735 16.624 30.735 21.1252C30.735 25.6264 34.3669 29.2759 38.8454 29.2759C43.3237 29.2759 46.9556 25.6264 46.9556 21.1252ZM38.8454 17.1184C40.8502 17.1184 42.476 18.9124 42.476 21.1251C42.476 23.3379 40.8502 25.132 38.8454 25.132C36.8405 25.132 35.2146 23.3379 35.2146 21.1251C35.2146 18.9124 36.8405 17.1184 38.8454 17.1184Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M47.5744 13.4455H51.9074V18.908H56.1814V13.4455H60.5144V29.0985H56.1814V23.225H51.9074V29.0985H47.5744V13.4455Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M61.6346 13.4455H65.9676V25.0605H70.7427V29.0985H61.6346V13.4455Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M80.3813 13.4455H71.627V29.0985H80.3813V25.501H75.9599V23.0488H80.3813V19.4512H75.9599V17.043H80.3813V13.4455Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.687 13.4455H81.354V29.0985H85.687V24.485C85.8575 24.7193 86.0281 24.9543 86.1989 25.1895C87.1499 26.4993 88.1081 27.8191 89.1063 29.0985H93.7634L93.6069 28.8782L93.6063 28.8774C92.1856 26.8782 90.7648 24.8788 89.3125 22.9022C90.5211 22.0253 91.6118 20.8854 91.9064 19.3948C92.555 16.852 90.5505 14.1922 88.0745 13.666C87.285 13.52 86.4876 13.4633 85.687 13.4455ZM85.687 20.1183V17.0642C85.8082 17.0709 85.9311 17.0744 86.0544 17.0779C86.6788 17.0955 87.3125 17.1134 87.7799 17.5535C88.3989 18.0796 88.3989 19.1901 87.7503 19.6871C87.3303 20.1257 86.7275 20.12 86.1414 20.1146C85.9876 20.1131 85.8349 20.1117 85.687 20.1183Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M30.2204 16.8629C29.1033 18.2064 27.9856 19.5507 26.8823 20.9049L33.9566 29.0985H28.2381L23.4334 23.491V29.0985H19.1006V13.4455H23.4334V18.0659L27.5399 13.4519H33.0427C32.1089 14.5914 31.1669 15.7244 30.2249 16.8574L30.2216 16.8614L30.2204 16.8629Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M6.77438 10.6262V0.11249H7.48692V4.53234H13.8487V0.11249H14.5612V10.6262H13.8487V5.19322H7.48692V10.6262H6.77438Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M15.6813 0.11249V10.6262H20.7217V9.96546H16.3939V5.19322H20.7217V4.53234H16.3939V0.773369H20.7217V0.11249H15.6813Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M42.6813 0.11249V10.6262H47.6924V9.96546H43.3938V0.11249H42.6813Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3407 0.11249V10.6262H49.0534V10.6171C50.7516 10.6526 52.5691 10.6442 53.9119 9.48278C56.4467 7.47905 56.3878 3.14752 53.8234 1.2029C52.5017 0.11037 50.7635 0.113101 49.1192 0.115685L49.0534 0.115786V0.11249H48.3407ZM49.0534 9.98494V0.760846L49.1339 0.760809C50.6102 0.76002 52.2918 0.759122 53.4697 1.82159C55.5329 3.44215 55.6509 6.91924 53.735 8.71664C52.535 10.0039 50.6667 10.0421 49.0534 9.98494Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M60.0723 0.11249V10.6262H65.0833V9.96546H60.785V0.11249H60.0723Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M86.4469 10.6262V0.11249H87.1596V4.83971L91.9452 0.11249H92.9559L87.841 5.16619L93.2915 10.6262H92.284L87.1596 5.4907V10.6262H86.4469Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M11.7611 13.3868V23.9005H12.4736V18.4821H15.9034V17.8213H12.4736V14.0476H15.9761V13.3868H11.7611Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66602 13.2795C8.64188 13.2795 11.0553 15.6843 11.0553 18.649C11.0553 21.6136 8.64188 24.0184 5.66602 24.0184C2.69006 24.0184 0.276681 21.6136 0.276681 18.649C0.276681 15.6843 2.69006 13.2795 5.66602 13.2795ZM10.4077 18.649C10.4077 16.0404 8.28431 13.9246 5.66602 13.9246C3.04754 13.9246 0.92428 16.0404 0.92428 18.649C0.92428 21.2575 3.04754 23.3733 5.66602 23.3733C8.28431 23.3733 10.4077 21.2575 10.4077 18.649Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9126 0C71.8885 0 74.3021 2.40469 74.3021 5.36964C74.3021 8.33413 71.8885 10.7389 68.9126 10.7389C65.9367 10.7389 63.5234 8.33413 63.5234 5.36964C63.5234 2.40469 65.9367 0 68.9126 0ZM73.6544 5.36964C73.6544 2.76106 71.531 0.64506 68.9126 0.64506C66.2944 0.64506 64.171 2.76106 64.171 5.36964C64.171 7.97801 66.2944 10.0938 68.9126 10.0938C71.531 10.0938 73.6544 7.97801 73.6544 5.36964Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7566 5.36964C85.7566 2.40469 83.3433 0 80.3674 0C77.3915 0 74.9782 2.40469 74.9782 5.36964C74.9782 8.33413 77.3915 10.7389 80.3674 10.7389C83.3433 10.7389 85.7566 8.33413 85.7566 5.36964ZM80.3674 0.64506C82.9858 0.64506 85.1092 2.76106 85.1092 5.36964C85.1092 7.97801 82.9858 10.0938 80.3674 10.0938C77.749 10.0938 75.6256 7.97801 75.6256 5.36964C75.6256 2.76106 77.749 0.64506 80.3674 0.64506Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0743 29.2173H96.7662L96.515 28.5551H96.1053V29.2173H95.8138V27.6065H96.515C96.71 27.6065 96.8535 27.6503 96.945 27.7382C97.0368 27.8257 97.0824 27.9392 97.0824 28.0785C97.0824 28.2856 96.9854 28.4278 96.7909 28.5056L97.0743 29.2173ZM96.1053 28.3227H96.4678C96.5726 28.3227 96.6509 28.3009 96.7025 28.2566C96.7536 28.2127 96.7792 28.1519 96.7792 28.0749C96.7792 28.0041 96.7541 27.9469 96.7036 27.9033C96.6531 27.8595 96.5823 27.8377 96.4914 27.8377H96.1053V28.3227Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5332 27.2889C97.2447 27.0016 96.8463 26.8238 96.4061 26.8238C95.9659 26.8238 95.5672 27.0016 95.279 27.2889C94.9906 27.5762 94.812 27.9734 94.812 28.4118C94.812 28.8504 94.9906 29.2475 95.279 29.5348C95.5672 29.8221 95.9659 30 96.4061 30C96.8463 30 97.2447 29.8221 97.5332 29.5348C97.8216 29.2475 98 28.8504 98 28.4118C98 27.9734 97.8216 27.5762 97.5332 27.2889ZM96.4061 27.1351C96.7598 27.1351 97.0802 27.2781 97.3122 27.5092C97.544 27.7401 97.6875 28.0594 97.6875 28.4118C97.6875 28.7644 97.544 29.0836 97.3122 29.3146C97.0802 29.5456 96.7598 29.6885 96.4061 29.6885C96.0522 29.6885 95.7318 29.5456 95.5 29.3146C95.268 29.0836 95.1247 28.7644 95.1247 28.4118C95.1247 28.0594 95.268 27.7401 95.5 27.5092C95.7318 27.2781 96.0522 27.1351 96.4061 27.1351Z",
    fill: "currentColor"
  }
));

export { KohlerBoldLogo };
